import { React, useLayoutEffect, useRef, useState } from 'react'
import { useAppContext } from '../../AppProvider';
import "../services/Services.css"
import GCMarqueeText from "../../GCMarqueeText"
import GC_Service_Cat from '../../GC_Service_Cat';
import GC_Process from '../../GC_Process';
import GC_FAQ from '../../GC_FAQ';
import { Helmet } from 'react-helmet-async';



import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { gsap } from "gsap";
import $ from 'jquery';

gsap.registerPlugin();
gsap.registerPlugin(ScrollTrigger);


const WebDevelopmentECommerce = (prop) => {

    const { gpageTransition, openCalender, openCalendly } = useAppContext();
    const marqueeText = "Web Development & E-Commerce"
    const processSteps = [
        {
            "title": "Planning",
            "desc": ["Requirements and analysis.", "Technical specs. documentation.", "Architecture planning and design.", "Technology stack selection.", "Timeline and milestone definition."]
        },
        {
            "title": "Design Integration",
            "desc": ["Design review and preparation.", "Component breakdown and planning.", "Responsive behavior planning.", "Interaction and animation.", "Asset optimization."]
        },
        {
            "title": "Development",
            "desc": ["Development environment.", "Front-end development and styling.", "Back-end development and APIs.", "Database implementation.", "CMS implementation."]
        },
        {
            "title": "Testing & Q.A.",
            "desc": ["Cross-browser testing.", "Mobile device testing.", "Performance testing.", "Accessibility testing.", "Functionality testing", "Security testing."]
        },
        {
            "title": "Launch",
            "desc": ["Staging environment review.", "Production deployment.",  "Domain configuration.", "Training and documentation.", "Support and warranty period."]
        },

    ];


    const subServices =
        [
            {
                "title": "Custom Website Development",
                "desc": `Tailor-made websites developed to match your business requirements, brand identity, and growth objectives. Every project is built with performance, security, and scalability in mind.`,
                "videoURL": "/assets/videos/services/web-development-e-commerce/custom-web-development",
                "accordian":
                    [
                        {
                            "title": "What’s Included",
                            "desc": ["Front-end development", "Responsive implementation", "CMS integration", "Performance optimization", "SEO-ready structure", "Cross-browser compatibility", "Security best practices"]
                        }
                        ,
                        {
                            "title": "Deliverables",
                            "desc": ["Fully functional website", "Source code repository", "CMS dashboard access", "Technical documentation", "Deployment configuration", "Launch support"]
                        },
                        {
                            "title": "Technologies",
                            "desc": ["Modern JavaScript frameworks (React,  Next.JS)", "Backend technologies (Node.js and PHP)", "Database solutions (PostgreSQL, MongoDB, MySQL)", "Cloud hosting and deployment (AWS, Vercel, Netlify)", "API development and integration", "CMS integration when needed"]
                        },
                        {
                            "title": "Ideal for",
                            "desc": ["Businesses requiring custom functionality", "Professional service providers", "Growing companies", "Corporate organizations"]
                        }

                    ]
            },
            {
                "title": "E-Commerce Development",
                "desc": "Powerful online stores designed to maximise conversions, streamline operations, and provide customers with a seamless shopping experience across all devices.",
                "videoURL": "/assets/videos/services/web-development-e-commerce/e-commerce",
                "accordian":
                    [
                        {
                            "title": "What’s Included",
                            "desc": ["Product catalog setup", "Shopping cart functionality", "Secure payment gateway integration", "Customer account system", "Order management workflows", "Shipping & tax configuration", "Inventory management integration"]
                        },
                        {
                            "title": "Deliverables",
                            "desc": ["Fully operational online store", "Product management dashboard", "Payment gateway connection", "Customer account portal", "Store administration training", "Deployment & launch assistance"]
                        },
                        {
                            "title": "Technologies",
                            "desc": ["Shopify", "WooCommerce", "Magento", "Stripe & PayPal Integrations", "Wordpress"]
                        },
                        {
                            "title": "Ideal for",
                            "desc": ["Retail brands", "Fashion businesses", "Product manufacturers", "DTC brands"]
                        }
                    ]
            },

            {
                "title": "CMS Development",
                "desc": "Flexible content management solutions that allow your team to update, publish, and manage website content without relying on developers.",
                "videoURL": "/assets/videos/services/web-development-e-commerce/crm",
                "accordian":
                    [
                        {
                            "title": "What’s Included",
                            "desc": ["Custom CMS implementation", "Content architecture planning", "User role management", "Dynamic page creation", "Media management tools", "SEO management capabilities", "Inventory management integration"]
                        },
                        {
                            "title": "Deliverables",
                            "desc": ["Configured CMS platform", "Content editing dashboard", "User access controls", "CMS documentation", "Team onboarding support"]
                        },
                        {
                            "title": "Technologies",
                            "desc": ["React", "Node.js", "Tailwind", "Php", "Laravel", "MySql", "PostgreSQL"]
                        },
                        {
                            "title": "Ideal for",
                            "desc": ["Marketing teams", "Content-driven businesses", "Publishers", "Corporate websites"]
                        }
                    ]
            },

            // {
            //     "title": "Web Application Development",
            //     "desc": "Custom web applications built to automate processes, improve workflows, and support complex business operations through modern cloud-based solutions.",
            //     "imageURL": "/assets/img/services/branding/brand-identity-design.webp",
            //     "accordian": 
            //     [
            //         {
            //             "title": "What’s Included",
            //             "desc": ["Business requirement analysis", "Database architecture", "Custom feature development", "API integrations", "Authentication systems", "Role-based permissions", "Performance optimization" ]
            //         },
            //          {
            //             "title": "Deliverables",
            //             "desc": ["Production-ready application", "Admin dashboard", "User management system", "API documentation", "Technical handover package", "Deployment setup"]
            //          },
            //          {
            //             "title": "Technologies",
            //              "desc": ["React", "Node.js", "Tailwind", "Php", "Laravel", "MySql", "PostgreSQL"]
            //          },
            //          {
            //             "title": "Ideal for",
            //             "desc": ["SaaS startups", "Internal business systems", "Customer portals", "Enterprise applications"]
            //         }
            //     ]    
            // },

            // {
            //     "title": "API & Third-Party Integrations",
            //     "desc": "Connect your website or application with external platforms, services, and business tools to automate workflows and improve operational efficiency.",
            //     "imageURL": "/assets/img/services/branding/brand-identity-design.webp",
            //     "accordian": 
            //     [
            //         {
            //             "title": "What’s Included",
            //             "desc": ["API development", "Third-party service integrations", "CRM connectivity", "Payment processing integration", "Marketing platform integration", "Data synchronization"]
            //         },
            //          {
            //             "title": "Deliverables",
            //             "desc": ["Connected systems", "Integration documentation", "API endpoints", "Authentication setup", "Testing reports"]
            //          },
            //          {
            //             "title": "Technologies",
            //              "desc": ["REST APIs", "GraphQL", "Stripe", "HubSpot", "Salesforce", "Zapier", "n8n"]
            //          },
            //          {
            //             "title": "Ideal for",
            //             "desc": ["Businesses using multiple platforms", "SaaS products", "E-commerce stores", "Workflow automation projects"]
            //         }
            //     ]    
            // },




        ]

    const faq =
        [
            {
                "question": "How long does website development take?",
                "answer": "Timeline varies by complexity. Landing pages: 1-2 weeks. Small business websites: 2-4 weeks. E-commerce sites: 6-8 weeks. Complex web applications: 10+ weeks. We provide detailed timelines during planning."
            },
            {
                "question": "How long does brand identity design take?",
                "answer": "Brand identity projects typically take 4 - 8 weeks, depending on project scope and complexity. Pitch decks usually require 1 - 2 weeks. Rebranding projects vary based on the extent of the transformation."
            },
            {
                "question": "Do you provide hosting and maintenance?",
                "answer": "Yes, we offer hosting solutions and ongoing maintenance packages including updates, backups, security monitoring, and technical support."
            },
            {
                "question": "Can you build e-commerce websites?",
                "answer": "Absolutely. We build e-commerce solutions using WooCommerce, Shopify, Webflow, or custom platforms, depending on your needs and budget."
            },
            {
                "question": "Will my website be mobile-friendly?",
                "answer": "Yes, all our websites are fully responsive and mobile-optimized. We build mobile-first, ensuring perfect experiences on all devices."
            },
            {
                "question": "Can you integrate with third-party services?",
                "answer": "Yes, we regularly integrate CRMs (Salesforce, HubSpot, Zoho, Monday), email marketing (Mailchimp, Brevo), payment processors (Stripe), analytics tools, and many other services."
            },
            {
                "question": "Do you offer SEO services?",
                "answer": "While we focus on development, we build SEO-friendly websites with clean code, fast performance, and proper technical SEO implementation. We can recommend SEO partners for ongoing optimization."
            },
            {
                "question": "What happens after the website launches?",
                "answer": "We provide training, documentation, and a warranty period. We also offer ongoing maintenance, updates, and support packages to keep your website running smoothly."
            },
            {
                "question": "Can you help with website content?",
                "answer": "We can assist with content migration and basic content entry. For copywriting, we can recommend content partners or work with your content team."
            },
            {
                "question": "Do you develop mobile apps?",
                "answer": "We specialize in web development including progressive web apps (PWAs). For native mobile app development, we can recommend trusted partners."
            }
        ]



    const sectionProcessRef = useRef(null);
    const [imageCount, setImageCount] = useState(0);

    // Scroll Trigger For WORK Section
    useLayoutEffect(() => {






        // PROCESS
        {
            let totalPlanets = processSteps.length;
            let planetArr = Array.from({ length: totalPlanets }, (_, i) => i * 360 / totalPlanets);

            function degreeToRadian(radians) {
                return radians * (Math.PI / 180);
            }
            function getScrollAmountProcess() {
                return -(2000);
            }


            const tlProcessInit = gsap.timeline({
                scrollTrigger: {
                    trigger: sectionProcessRef.current,
                    pin: false,
                    start: 'top 90%',
                    end: "top 5%",

                    scrub: 1,
                    ease: 'none',
                    markers: false,

                    onUpdate: (self) => {
                        $('.planet').each(function () {
                            $(this).css("opacity", 1);
                        });



                        $('#galaxyPath').css("stroke-dashoffset", (-2100 * self.progress - 2100));
                        let r = (Math.floor($('.solar-system').width() - 12) / 2);

                        for (let i = 0; i < planetArr.length; i++) {
                            let degF = -90 + (planetArr[i] * self.progress);
                            let degFPer = degreeToRadian(degF);
                            $('.planet-' + (i + 1)).css("left", (Math.cos(degFPer) * (r)) + (r - 4) + "px");
                            $('.planet-' + (i + 1)).css("top", (Math.sin(degFPer) * (r)) + (r - 4) + "px");
                        }

                    }

                },
            });

            const tlProcess = gsap.timeline({
                scrollTrigger: {
                    trigger: sectionProcessRef.current,
                    pin: true,
                    start: 'top 8.2%',

                    end: () => `+=${getScrollAmountProcess() * -1}`,
                    scrub: 1,
                    ease: 'none',
                    markers: false,

                    onUpdate: (self) => {
                        let progress = self.progress

                        $('#galaxyPathActive').css("stroke-dashoffset", (-2100 * progress - 2100));

                        let diff = 1 / planetArr.length;
                        for (let i = 0; i < planetArr.length; i++) {
                            $('.planet-' + (i + 1)).removeClass('active');
                            $('.planet-desc' + (i + 1)).removeClass('active');



                            if (progress >= (diff * i) - .01) {


                                $('.solar-system .heading').addClass("active");
                                $('.solar-system .content').css("transform", "translateY(" + (- 1.11 * i) + "em)");
                                $('.planet-' + (i + 1)).addClass('active');

                                $('.solar-system .details div').each(function (e) {
                                    console.log("1")
                                    $(this).removeClass('active')

                                });

                                $('.planet-desc-' + (i + 1)).addClass('active');
                            }

                            if (progress == 0) {
                                $('.planet-1').removeClass('active')
                                $('.planet-desc-1').removeClass('active')

                                $('.solar-system .heading').removeClass("active");
                                $('.solar-system .content').css("transform", "translateY(1.1em)");
                            }
                        }


                    }
                },
            }, [imageCount]);
        }

        // Why Choose Us
        {



            const tlWhyChooseUs = gsap.timeline({
                scrollTrigger: {
                    trigger: '.page-services.why-choose-us .hh2 ',
                    start: 'top 70%',
                    end: 'bottom 70%',
                    scrub: 1,
                    markers: false,
                    ease: 'none',
                },
            });

            tlWhyChooseUs.fromTo('.page-services.why-choose-us .hh2 div',
                {
                    opacity: 0,
                    y: 100
                },
                {
                    opacity: 1,
                    y: 0,
                    stagger: .05

                });


            const whyChooseUsObj = document.querySelectorAll('.why-choose-us .card ');

            whyChooseUsObj.forEach((item, i) => {

                gsap.fromTo(item,
                    {
                        opacity: 0,
                        scale: 0,
                        y: 100
                    },
                    {
                        opacity: 1,
                        scale: 1,
                        y: 0,
                        ease: 'none',

                        scrollTrigger:
                        {
                            trigger: item,
                            scrub: 'none',
                            markers: false,
                            start: "top 90%",
                            end: "bottom 90%"
                        }

                    });

            });


        }

        {
            const tlCTA = gsap.timeline({

                scrollTrigger: {
                    trigger: '.page-services.cta-1 .container ',
                    start: 'top 70%',
                    end: 'bottom 70%',
                    scrub: 1,
                    markers: false,

                },
            });

            tlCTA.fromTo('.page-services.cta-1 .items-center .content-wrapper',
                {
                    opacity: 0,
                    y: 100
                },
                {
                    opacity: 1,
                    y: 0,
                    stagger: .08

                });
        }


        // FAQ
        {

            gsap.fromTo('section.faq .hh2',
                {
                    opacity: 0,
                    y: 100
                },
                {
                    scrollTrigger: {
                        trigger: 'section.faq .hh2 ',
                        start: 'top 80%',
                        end: 'bottom 80%',
                        scrub: 1,
                        markers: false,

                    },
                    opacity: 1,
                    y: 0,
                    stagger: .08

                });





            const faqObj = document.querySelectorAll('.faq .accordion .accordion-item');


            faqObj.forEach((item, i) => {

                gsap.fromTo(item,
                    {
                        opacity: 0,

                        y: 100
                    },
                    {
                        opacity: 1,

                        y: 0,
                        ease: 'none',

                        scrollTrigger:
                        {
                            trigger: item,
                            scrub: 'none',
                            markers: false,
                            start: "top 90%",
                            end: "bottom 100%"
                        }

                    });


            });

        }


        return () => {
            ScrollTrigger.killAll();
        };

    });

    const onImgLoad = () => {

        setImageCount(prev => prev + 1);
    };
    return (
        <>
            <Helmet>
                <link rel="canonical" href="https://robustik.com/services/web-development-e-commerce" />
            </Helmet>
            <section className='page-services hero'>
                <div className='container '>
                    <div className="flex flex-wrap -mx-5">

                        <div className="w-full xl:w-1/2 relative  md:hidden mb-10 px-5 ">
                            <img src="/assets/img/services/web-development-e-commerce/hero-image.webp" fetchPriority='high' width="100%" height="auto" alt={marqueeText} data-aos="zoom-in" data-aos-delay="100" onLoad={onImgLoad} />
                        </div>


                        <div className="w-full xl:w-1/2 flex justify-center flex-col px-5">
                            <div className="hh1" data-aos="fade-up" data-aos-delay="200">
                                <span className="text-primary font-semibold ">Performance-Driven Website</span> for Modern Businesses
                                {/* Websites That Don’t Just Look Good <span className="text-primary font-semibold ">—They Perform </span>                 */}
                            </div>
                            <div data-aos="fade-up" data-aos-delay="300">
                                <p>
                                    We build fast, scalable, and secure digital experiences engineered for performance and long-term growth. From custom business websites and enterprise platforms to powerful online stores and web applications.
                                </p>
                            </div>

                            <div className='mt-5 '>
                                <button onClick={openCalendly} data-aos="fade-up" data-aos-delay="400">
                                    <div>GET FREE CONSULTAION<i></i></div>
                                </button>
                            </div>
                        </div>

                        <div className="w-full xl:w-1/2 relative hidden sm:block mt-10 mb-10 px-5 ">
                            <img src="/assets/img/services/web-development-e-commerce/hero-image.webp" fetchPriority='high' width="724px" heihht="617px" alt={marqueeText} data-aos="zoom-in" data-aos-delay="100" onLoad={onImgLoad} />
                        </div>
                    </div>
                </div>
            </section>

            <div data-aos="fade-up" data-aos-delay="300">
                <GCMarqueeText text={marqueeText} />
            </div>



            <GC_Service_Cat subServices={subServices} onImgLoad={onImgLoad} marqueeText={marqueeText} />

            <GC_Process ref={sectionProcessRef} processSteps={processSteps} />

            <section className="page-services why-choose-us">
                <div className="container">
                    <div className='hh2 text-center'>
                        <div>Why Choose Us for</div>
                        <div className='text-primary hh1'>{marqueeText}</div>
                    </div>


                    <div className='card-wrapper mt-20'>


                        <div className=' flex flex-wrap  -mx-3 '>
                            <div className='xl:w-1/3 px-3'>
                                <div className='card mb-5 md:mb-0'>
                                    <svg width="71" height="70" viewBox="0 0 71 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_298_588)">
                                            <path d="M7.981 39.0024C7.6015 39.0024 7.26293 38.9506 7.00249 38.895C6.11326 38.7025 5.31706 38.1471 4.82222 37.377L0.554704 30.742C-0.312193 29.3943 -0.148487 27.643 0.956528 26.4804L16.2519 10.3633L13.0373 1.2403C12.9666 1.03666 12.9815 0.810807 13.0819 0.618275C13.1824 0.425744 13.361 0.285048 13.573 0.22951C13.6735 0.203592 16.0286 -0.407325 18.9791 0.477579C21.6058 1.26622 25.2148 3.4285 27.6629 9.23776C29.8283 9.43029 38.181 10.5781 42.0765 17.0797C46.3924 24.2848 45.2464 37.0104 45.1981 37.5473C45.1571 37.9768 44.7776 38.2915 44.346 38.2508C43.9145 38.21 43.5982 37.8287 43.6391 37.4029C43.6503 37.277 44.7851 24.6477 40.7334 17.8795C36.7635 11.2482 27.1904 10.7669 27.0937 10.7595C26.7849 10.7447 26.5133 10.5522 26.3979 10.2671C24.6306 5.82403 22.0076 3.04343 18.607 1.99191C17.0481 1.51058 15.6677 1.52169 14.8306 1.60315L17.8927 10.293C17.9894 10.567 17.9224 10.8743 17.7215 11.0853L2.09503 27.5542C1.48857 28.1947 1.39556 29.1611 1.87551 29.9016L6.14675 36.5365C6.42207 36.9623 6.85738 37.2659 7.34106 37.3733C8.89254 37.7102 9.86362 36.9068 10.3064 34.9111C10.6152 33.5226 11.7016 32.4637 13.0745 32.2157C13.5544 32.1305 14.0939 32.0972 14.6743 32.1268C17.3122 32.249 20.977 32.2157 22.0374 32.2008C22.1453 32.2008 22.2532 32.1897 22.3611 32.1675C23.8009 31.9046 28.4926 30.6495 28.4926 25.5511C28.4926 25.1216 28.8423 24.7699 29.2777 24.7699C29.713 24.7699 30.0627 25.1179 30.0627 25.5511C30.0627 32.0194 23.8865 33.4782 22.6476 33.7041C22.4541 33.7411 22.2569 33.7596 22.0597 33.7596C20.9882 33.7744 17.2862 33.8077 14.6036 33.6856C14.1386 33.6633 13.7181 33.6856 13.3535 33.7522C12.602 33.8892 12.0067 34.4742 11.8355 35.2517C11.1361 38.3915 9.30553 39.0061 7.981 39.0061V39.0024Z" fill="#DC0000" />
                                            <path d="M9.11512 59.6473C8.68353 59.6473 8.33008 59.2993 8.33008 58.8661V53.2975C8.33008 52.9864 8.51611 52.705 8.79887 52.5829C8.82492 52.5718 11.4144 51.4166 14.2607 48.4323C16.8874 45.6814 20.2806 40.7681 21.5419 32.9632C21.6089 32.5374 22.0144 32.2486 22.4386 32.3152C22.8664 32.3819 23.1566 32.7854 23.0897 33.2075C21.7614 41.4494 18.1413 46.6514 15.3397 49.5653C12.9845 52.0127 10.8229 53.2937 9.89645 53.7788V58.8623C9.89645 59.2918 9.54671 59.6436 9.1114 59.6436L9.11512 59.6473Z" fill="#DC0000" />
                                            <path d="M29.374 69.9998H6.63749C4.5614 69.9998 2.87598 68.3189 2.87598 66.2566V61.9727C2.87598 59.9067 4.56512 58.2295 6.63749 58.2295H27.0226C27.4542 58.2295 27.8076 58.5775 27.8076 59.0107C27.8076 59.4439 27.4579 59.792 27.0226 59.792H6.63749C5.4283 59.792 4.44234 60.7731 4.44234 61.9764V66.2603C4.44234 67.4636 5.4283 68.4448 6.63749 68.4448H29.374C29.8056 68.4448 30.1591 68.7928 30.1591 69.226C30.1591 69.6592 29.8093 70.0072 29.374 70.0072V69.9998Z" fill="#DC0000" />
                                            <path d="M44.7139 68.815C37.3657 68.815 31.3867 62.865 31.3867 55.5525C31.3867 48.24 37.3657 42.29 44.7139 42.29C52.062 42.29 58.041 48.24 58.041 55.5525C58.041 62.865 52.062 68.815 44.7139 68.815ZM44.7139 43.8488C38.2289 43.8488 32.9531 49.099 32.9531 55.5525C32.9531 62.006 38.2289 67.2562 44.7139 67.2562C51.1989 67.2562 56.4746 62.006 56.4746 55.5525C56.4746 49.099 51.1989 43.8488 44.7139 43.8488Z" fill="#DC0000" />
                                            <path d="M44.7142 62.9655C40.6067 62.9655 37.2656 59.6407 37.2656 55.5531C37.2656 51.4655 40.6067 48.1406 44.7142 48.1406C48.8218 48.1406 52.1629 51.4655 52.1629 55.5531C52.1629 59.6407 48.8218 62.9655 44.7142 62.9655ZM44.7142 49.6994C41.4736 49.6994 38.8357 52.3245 38.8357 55.5494C38.8357 58.7743 41.4736 61.3994 44.7142 61.3994C47.9549 61.3994 50.5928 58.7743 50.5928 55.5494C50.5928 52.3245 47.9549 49.6994 44.7142 49.6994Z" fill="#DC0000" />
                                            <path d="M70.2147 56.5634H44.9481C44.5165 56.5634 44.1631 56.2154 44.1631 55.7822C44.1631 55.349 44.5128 55.001 44.9481 55.001H70.2147C70.6462 55.001 70.9997 55.349 70.9997 55.7822C70.9997 56.2154 70.65 56.5634 70.2147 56.5634Z" fill="#DC0000" />
                                            <path d="M65.7724 56.586C65.5715 56.586 65.3706 56.5083 65.2181 56.3565C64.913 56.0528 64.913 55.5567 65.2181 55.2531L69.6233 50.8693C69.9283 50.5657 70.4269 50.5657 70.732 50.8693C71.0371 51.1729 71.0371 51.6691 70.732 51.9727L66.3268 56.3565C66.1743 56.5083 65.9734 56.586 65.7724 56.586Z" fill="#DC0000" />
                                            <path d="M70.1776 60.9552C69.9767 60.9552 69.7758 60.8774 69.6233 60.7256L65.2181 56.3418C64.913 56.0382 64.913 55.5421 65.2181 55.2384C65.5232 54.9348 66.0217 54.9348 66.3268 55.2384L70.732 59.6222C71.0371 59.9258 71.0371 60.422 70.732 60.7256C70.5794 60.8774 70.3785 60.9552 70.1776 60.9552Z" fill="#DC0000" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_298_588">
                                                <rect width="71" height="70" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>

                                    <div className="mt-10 hh5">Strategic, Not Just Visual</div>
                                    <p>We don’t just design websites — we create digital tools aligned with your business objectives.</p>
                                </div>
                            </div>

                            <div className='xl:w-1/3 px-3'>
                                <div className='card mb-5 md:mb-0'>
                                    <svg width="61" height="60" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_298_608)">
                                            <path d="M2.61225 47.3475C2.01933 47.3475 1.53821 46.8689 1.53821 46.2791V12.3694H54.7082V20.9774H56.2464V2.59858C56.2464 1.16616 55.0742 0 53.6342 0H2.61225C1.1723 0 0 1.16616 0 2.59858V46.2757C0 47.7081 1.1723 48.8743 2.61225 48.8743H21.5045V47.3441H2.61225V47.3475ZM1.53821 2.59858C1.53821 2.00876 2.01933 1.53017 2.61225 1.53017H53.6308C54.2237 1.53017 54.7049 2.00876 54.7049 2.59858V10.8426H1.53821V2.59858Z" fill="#DC0000" />
                                            <path d="M11.1197 4.64062H6.50844C5.63091 4.64062 4.91602 5.35178 4.91602 6.22472C4.91602 7.09765 5.63091 7.80881 6.50844 7.80881H11.1197C11.9972 7.80881 12.7121 7.09765 12.7121 6.22472C12.7121 5.35178 11.9972 4.64062 11.1197 4.64062Z" fill="#DC0000" />
                                            <path d="M21.3863 4.64062H16.775C15.8975 4.64062 15.1826 5.35178 15.1826 6.22472C15.1826 7.09765 15.8975 7.80881 16.775 7.80881H21.3863C22.2638 7.80881 22.9787 7.09765 22.9787 6.22472C22.9787 5.35178 22.2638 4.64062 21.3863 4.64062Z" fill="#DC0000" />
                                            <path d="M48.1483 39.3598C47.7689 39.3598 47.4605 39.0531 47.4605 38.6756C47.4605 36.1243 44.8788 34.8064 43.7776 34.8064C43.3982 34.8064 43.0898 34.4997 43.0898 34.1222C43.0898 33.7447 43.3982 33.4414 43.7776 33.4414C45.5429 33.4414 48.8327 35.2378 48.8327 38.6756C48.8327 39.0531 48.5244 39.3565 48.1449 39.3565L48.1483 39.3598Z" fill="#DC0000" />
                                            <path d="M43.9609 60.0004H39.0346C38.6991 60.0004 38.4112 59.7578 38.3569 59.4275L37.6827 55.265C36.3105 54.9111 34.9959 54.3718 33.7728 53.6539L30.3372 56.1245C30.0628 56.3199 29.6867 56.2896 29.4495 56.0537L25.9665 52.5889C25.7294 52.353 25.6989 51.9789 25.8954 51.7059L28.3789 48.2883C27.6572 47.0715 27.1117 45.7638 26.7594 44.3988L22.575 43.7281C22.243 43.6742 21.999 43.3877 21.999 43.054V38.1534C21.999 37.8198 22.243 37.5333 22.575 37.4794L26.7594 36.8086C27.1151 35.4403 27.6572 34.1359 28.3789 32.9192L25.8954 29.5016C25.6989 29.2286 25.7294 28.8579 25.9665 28.6186L29.4495 25.1538C29.6867 24.9178 30.0628 24.8875 30.3372 25.083L33.7728 27.5535C34.9959 26.8356 36.3105 26.293 37.6827 25.9425L38.3569 21.78C38.4112 21.4497 38.6991 21.207 39.0346 21.207H43.9609C44.2963 21.207 44.5843 21.4497 44.6385 21.78L45.3128 25.9425C46.6884 26.2963 47.9996 26.8356 49.2227 27.5535L52.6583 25.083C52.9327 24.8875 53.3054 24.9178 53.546 25.1538L57.029 28.6186C57.2661 28.8545 57.2966 29.2286 57.1001 29.5016L54.6166 32.9192C55.3383 34.1393 55.8838 35.4436 56.2361 36.8086L60.4205 37.4794C60.7525 37.5333 60.9965 37.8198 60.9965 38.1534V43.054C60.9965 43.3877 60.7525 43.6742 60.4205 43.7281L56.2361 44.3988C55.8804 45.7672 55.3383 47.0715 54.6166 48.2883L57.1001 51.7059C57.2966 51.9789 57.2661 52.3496 57.029 52.5889L53.546 56.0537C53.3088 56.2896 52.9327 56.3199 52.6583 56.1245L49.2227 53.6539C47.9996 54.3718 46.685 54.9145 45.3128 55.265L44.6385 59.4275C44.5843 59.7578 44.2963 60.0004 43.9609 60.0004ZM39.6173 58.6354H43.3748L44.0287 54.5977C44.0727 54.3213 44.2828 54.1022 44.5538 54.0415C46.0921 53.6978 47.549 53.0945 48.8839 52.2552C49.1211 52.1069 49.426 52.117 49.653 52.2788L52.9869 54.6752L55.6432 52.0328L53.2342 48.7163C53.0716 48.4905 53.0615 48.1871 53.2105 47.9512C54.0542 46.6233 54.6607 45.174 55.0062 43.6438C55.0672 43.3708 55.2908 43.1652 55.5653 43.1214L59.6243 42.4709V38.7332L55.5653 38.0827C55.2875 38.0388 55.0672 37.8299 55.0062 37.5602C54.6607 36.0301 54.0542 34.5808 53.2105 33.2529C53.0615 33.0169 53.0716 32.7136 53.2342 32.4878L55.6432 29.1713L52.9869 26.5255L49.653 28.9219C49.426 29.0837 49.1211 29.0938 48.8839 28.9455C47.549 28.1063 46.0921 27.503 44.5538 27.1592C44.2794 27.0985 44.0727 26.8761 44.0287 26.6031L43.3748 22.5653H39.6173L38.9634 26.6031C38.9194 26.8794 38.7093 27.0985 38.4383 27.1592C36.9 27.503 35.4431 28.1063 34.1082 28.9455C33.8711 29.0938 33.5661 29.0837 33.3391 28.9219L30.0052 26.5255L27.3489 29.1713L29.7579 32.4878C29.9205 32.7136 29.9307 33.0169 29.7816 33.2529C28.9379 34.5808 28.3314 36.0301 27.9859 37.5602C27.9249 37.8333 27.7013 38.0388 27.4268 38.0827L23.3678 38.7332V42.4709L27.4268 43.1214C27.7046 43.1652 27.9249 43.3742 27.9859 43.6438C28.3314 45.174 28.9379 46.6233 29.7816 47.9512C29.9307 48.1871 29.9205 48.4905 29.7579 48.7163L27.3489 52.0328L30.0052 54.6785L33.3391 52.2822C33.5661 52.1204 33.8711 52.1103 34.1082 52.2586C35.4431 53.0978 36.9034 53.7011 38.4383 54.0449C38.7127 54.1056 38.9194 54.328 38.9634 54.601L39.6173 58.6388V58.6354Z" fill="#DC0000" />
                                            <path d="M41.4979 51.0958C35.6805 51.0958 30.9473 46.3874 30.9473 40.597C30.9473 34.8067 35.6805 30.1016 41.4979 30.1016C47.3154 30.1016 52.052 34.81 52.052 40.597C52.052 46.384 47.3187 51.0958 41.4979 51.0958ZM41.4979 31.4666C36.436 31.4666 32.3195 35.5616 32.3195 40.597C32.3195 45.6324 36.436 49.7308 41.4979 49.7308C46.5598 49.7308 50.6798 45.6358 50.6798 40.597C50.6798 35.5583 46.5632 31.4666 41.4979 31.4666Z" fill="#DC0000" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_298_608">
                                                <rect width="61" height="60" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>

                                    <div className="mt-10 hh5">Custom-Built Solutions</div>
                                    <p>No templates, no shortcuts. Every website is crafted specifically for your brand and audience.</p>
                                </div>
                            </div>
                            <div className='xl:w-1/3 px-3'>
                                <div className='card '>
                                    <svg width="69" height="60" viewBox="0 0 69 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_298_618)">
                                            <path d="M65.7952 60C67.5618 60 69 58.5684 69 56.8099V3.19013C69 1.43163 67.5618 0 65.7952 0H3.20476C1.43819 0 0 1.43163 0 3.19013V56.8099C0 58.5684 1.43819 60 3.20476 60H65.7952ZM3.20476 58.1256C2.47735 58.1256 1.88711 57.5381 1.88711 56.814V15.1852H67.117V56.8099C67.117 57.534 66.5268 58.1215 65.7994 58.1215H3.20476V58.1256ZM1.88711 13.3108V3.19013C1.88711 2.46604 2.47735 1.87849 3.20476 1.87849H65.7952C66.5226 1.87849 67.1129 2.46604 67.1129 3.19013V13.3108H1.88711Z" fill="#DC0000" />
                                            <path d="M13.642 5.69727H7.98486C6.9083 5.69727 6.03125 6.57031 6.03125 7.64196C6.03125 8.71361 6.9083 9.58665 7.98486 9.58665H13.642C14.7186 9.58665 15.5956 8.71361 15.5956 7.64196C15.5956 6.57031 14.7186 5.69727 13.642 5.69727Z" fill="#DC0000" />
                                            <path d="M26.2368 5.69727H20.5796C19.503 5.69727 18.626 6.57031 18.626 7.64196C18.626 8.71361 19.503 9.58665 20.5796 9.58665H26.2368C27.3133 9.58665 28.1904 8.71361 28.1904 7.64196C28.1904 6.57031 27.3133 5.69727 26.2368 5.69727Z" fill="#DC0000" />
                                            <path d="M46.5714 43.5116C47.0827 43.4413 47.4443 42.9696 47.3736 42.4607C47.303 41.9517 46.8291 41.5918 46.3178 41.6621L38.3288 44.3929C38.2249 44.4054 38.1293 44.4426 38.042 44.484C37.3229 43.2799 36.0053 42.4731 34.5047 42.4731C32.2352 42.4731 30.3896 44.3102 30.3896 46.5694C30.3896 48.8285 32.2352 50.6656 34.5047 50.6656C36.7742 50.6656 38.6198 48.8285 38.6198 46.5694C38.6198 46.4576 38.6156 46.3459 38.6031 46.2383L46.5714 43.5116ZM34.5006 48.7995C33.266 48.7995 32.2601 47.7982 32.2601 46.5694C32.2601 45.3405 33.266 44.3392 34.5006 44.3392C35.7351 44.3392 36.741 45.3405 36.741 46.5694C36.741 47.7982 35.7351 48.7995 34.5006 48.7995Z" fill="#DC0000" />
                                            <path d="M59.54 46.5736C59.54 32.8325 48.3088 21.6484 34.5005 21.6484C20.6921 21.6484 9.46094 32.8284 9.46094 46.5736C9.46094 48.1707 9.61473 49.7306 9.9057 51.245L9.97636 51.6919L17.1465 50.6368L16.9262 49.5403C16.8099 48.8659 16.7309 48.179 16.6935 47.4798H20.8127C21.3323 47.4798 21.7521 47.0619 21.7521 46.5447C21.7521 46.0274 21.3323 45.6095 20.8127 45.6095H16.6935C16.9221 41.4016 18.6263 37.5742 21.3073 34.6448L24.3167 37.6404C24.4996 37.8225 24.7407 37.9135 24.9818 37.9135C25.2229 37.9135 25.4639 37.8225 25.6468 37.6404C26.0126 37.2763 26.0126 36.6846 25.6468 36.3205L22.6458 33.3331C25.6344 30.6809 29.5208 29.0134 33.7897 28.8438V33.1511C33.7897 33.6683 34.2095 34.0862 34.7291 34.0862C35.2486 34.0862 35.6685 33.6683 35.6685 33.1511V28.8645C39.9165 29.1376 43.7656 30.9044 46.6918 33.6352L43.6741 36.6391C43.3083 37.0032 43.3083 37.5949 43.6741 37.959C43.857 38.1411 44.0981 38.2321 44.3392 38.2321C44.5803 38.2321 44.8214 38.1411 45.0042 37.959L47.9929 34.9841C50.5907 37.9756 52.1994 41.836 52.3199 46.0647H48.1841C47.6645 46.0647 47.2447 46.4826 47.2447 46.9998C47.2447 47.517 47.6645 47.9349 48.1841 47.9349H52.2742C52.2409 48.39 52.1869 48.8369 52.1162 49.2796H52.1121L51.8419 50.6368L59.0121 51.6919L59.037 51.5429C59.3654 49.9375 59.54 48.2742 59.54 46.5695V46.5736ZM34.5005 26.9612C23.635 26.9612 14.798 35.7578 14.798 46.5736C14.798 47.5791 14.877 48.568 15.0267 49.5362L11.6016 50.012C11.4312 48.8907 11.3397 47.7446 11.3397 46.5778C11.3397 33.8628 21.7313 23.5228 34.5005 23.5228C47.2696 23.5228 57.6612 33.8669 57.6612 46.5778C57.6612 47.7446 57.5697 48.8948 57.3993 50.0161L53.9742 49.5403C54.1239 48.5721 54.2029 47.5832 54.2029 46.5778C54.2029 35.7619 45.3659 26.9653 34.5005 26.9653V26.9612Z" fill="#DC0000" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_298_618">
                                                <rect width="69" height="60" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>

                                    <div className="mt-10 hh5">Performance & SEO Focused</div>
                                    <p>Our websites are optimized for speed, usability, and search engines from day one.</p>
                                </div>
                            </div>
                        </div>

                        <div className=' flex flex-wrap  -mx-3 mt-6'>
                            <div className='xl:w-1/3 px-3'>
                                <div className='card mb-10 md:mb-0'>
                                    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_299_627)">
                                            <path d="M65.6989 30.6994C63.6154 30.6994 61.8791 32.1778 61.4837 34.1444H53.3217C53.1188 29.7264 51.3516 25.7141 48.5633 22.6542L54.3359 16.8816C56.0068 17.9921 58.2794 17.8099 59.7544 16.3349C61.4356 14.6537 61.4356 11.9307 59.7544 10.2495C58.0731 8.56825 55.3502 8.56825 53.6689 10.2495C52.1974 11.721 52.0152 13.997 53.1223 15.668L47.3497 21.4405C44.2863 18.6522 40.2775 16.885 35.8595 16.6822V8.52011C37.8261 8.12129 39.3045 6.38505 39.3045 4.30499C39.3045 1.92925 37.3791 0.00390625 35.0034 0.00390625C32.6277 0.00390625 30.7023 1.92925 30.7023 4.30499C30.7023 6.38848 32.1807 8.12473 34.1473 8.52011V16.6822C29.7293 16.885 25.7171 18.6522 22.6571 21.4405L16.8845 15.668C17.995 13.997 17.8128 11.7244 16.3379 10.2495C14.6566 8.56825 11.9337 8.56825 10.2524 10.2495C8.57118 11.9307 8.57118 14.6537 10.2524 16.3349C11.7239 17.8065 14 17.9887 15.6709 16.8816L21.4435 22.6542C18.6552 25.7176 16.888 29.7264 16.6851 34.1444H8.52304C8.12422 32.1778 6.38797 30.6994 4.30792 30.6994C1.93218 30.6994 0.00683594 32.6247 0.00683594 35.0005C0.00683594 37.3762 1.93218 39.3015 4.30792 39.3015C6.39141 39.3015 8.12766 37.8232 8.52304 35.8566H16.6851C16.888 40.2745 18.6552 44.2868 21.4435 47.3467L15.6709 53.1193C14 52.0088 11.7274 52.191 10.2524 53.666C8.57118 55.3472 8.57118 58.0702 10.2524 59.7514C11.9337 61.4327 14.6566 61.4327 16.3379 59.7514C17.8094 58.2799 17.9916 56.0039 16.8845 54.333L22.6571 48.5604C25.7205 51.3487 29.7293 53.1159 34.1473 53.3187V61.4808C32.1807 61.8796 30.7023 63.6159 30.7023 65.696C30.7023 68.0717 32.6277 69.997 35.0034 69.997C37.3791 69.997 39.3045 68.0717 39.3045 65.696C39.3045 63.6125 37.8261 61.8762 35.8595 61.4808V53.3187C40.2775 53.1159 44.2897 51.3487 47.3497 48.5604L53.1223 54.333C52.0117 56.0039 52.194 58.2765 53.6689 59.7514C55.3502 61.4327 58.0731 61.4327 59.7544 59.7514C61.4356 58.0702 61.4356 55.3472 59.7544 53.666C58.2829 52.1945 56.0068 52.0123 54.3359 53.1193L48.5633 47.3467C51.3516 44.2834 53.1188 40.2745 53.3217 35.8566H61.4837C61.8826 37.8232 63.6188 39.3015 65.6989 39.3015C68.0746 39.3015 70 37.3762 70 35.0005C70 32.6247 68.0746 30.6994 65.6989 30.6994ZM35 51.6513C25.803 51.6513 18.3492 44.1974 18.3492 35.0005C18.3492 25.8035 25.803 18.3497 35 18.3497C44.1969 18.3497 51.6507 25.8035 51.6507 35.0005C51.6507 44.1974 44.1969 51.6513 35 51.6513Z" fill="#DC0000" />
                                            <path d="M35.0831 37.9839C36.3416 37.9839 37.528 37.4923 38.4186 36.6018C39.3092 35.7113 39.801 34.5286 39.801 33.2668V30.9427C39.801 29.6843 39.3092 28.4982 38.4186 27.6077C37.528 26.7172 36.3451 26.2256 35.0831 26.2256C33.8211 26.2256 32.6382 26.7172 31.7476 27.6077C30.857 28.4982 30.3652 29.6809 30.3652 30.9427V33.2668C30.3652 34.5252 30.857 35.7113 31.7476 36.6018C32.6382 37.4923 33.8211 37.9839 35.0831 37.9839Z" fill="#DC0000" />
                                            <path d="M43.665 41.7766C43.4897 41.0408 43.0049 40.4185 42.331 40.0678L38.174 37.9121C37.2663 38.5172 36.2004 38.8438 35.083 38.8438C33.9655 38.8438 32.8996 38.5172 31.9919 37.9121L27.835 40.0678C27.1645 40.4151 26.6763 41.0374 26.5009 41.7766L25.7686 44.8674C27.3708 46.4146 29.3582 47.5629 31.569 48.1646C32.6899 48.4671 33.8658 48.6287 35.083 48.6287C36.3001 48.6287 37.476 48.4671 38.5969 48.1646C40.8112 47.5663 42.7951 46.4146 44.3974 44.8674L43.665 41.7766Z" fill="#DC0000" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_299_627">
                                                <rect width="70" height="70" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>

                                    <div className="mt-10 hh5">Transparent Collaboration</div>
                                    <p>Clear timelines, regular updates, and no hidden surprises.</p>
                                </div>
                            </div>

                            <div className='xl:w-1/3 px-3'>
                                <div className='card mb-10 md:mb-0'>
                                    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_299_657)">
                                            <path d="M47.5742 3.20017V0L44.3766 0V3.20017H47.5742Z" fill="#DC0000" />
                                            <path d="M41.1855 3.20017V0L37.9879 0V3.20017H41.1855Z" fill="#DC0000" />
                                            <path d="M34.793 3.20017V0L31.5954 0V3.20017H34.793Z" fill="#DC0000" />
                                            <path d="M28.4043 3.20017V0L25.2067 0V3.20017H28.4043Z" fill="#DC0000" />
                                            <path d="M22.0156 3.20017V0L18.818 0V3.20017H22.0156Z" fill="#DC0000" />
                                            <path d="M15.623 3.20017V0L12.4254 0V3.20017H15.623Z" fill="#DC0000" />
                                            <path d="M47.5742 60V56.7998H44.3766V60H47.5742Z" fill="#DC0000" />
                                            <path d="M41.1846 60V56.7998H37.987V60H41.1846Z" fill="#DC0000" />
                                            <path d="M34.7959 60V56.7998H31.5983V60H34.7959Z" fill="#DC0000" />
                                            <path d="M28.4043 60V56.7998H25.2067V60H28.4043Z" fill="#DC0000" />
                                            <path d="M22.0156 60V56.7998H18.818V60H22.0156Z" fill="#DC0000" />
                                            <path d="M15.626 60V56.7998H12.4284V60H15.626Z" fill="#DC0000" />
                                            <path d="M49.0548 53.5741H10.7794C8.31084 53.5741 6.30273 51.5644 6.30273 49.0939V10.7879C6.30273 8.31732 8.31084 6.30762 10.7794 6.30762H49.0516C51.5202 6.30762 53.5283 8.31732 53.5283 10.7879V49.0939C53.5283 51.5644 51.5202 53.5741 49.0516 53.5741H49.0548ZM10.7794 7.58769C9.01751 7.58769 7.58178 9.02456 7.58178 10.7879V49.0939C7.58178 50.8572 9.01751 52.2941 10.7794 52.2941H49.0516C50.8135 52.2941 52.2492 50.8572 52.2492 49.0939V10.7879C52.2492 9.02456 50.8135 7.58769 49.0516 7.58769H10.7794Z" fill="#DC0000" />
                                            <path d="M3.19761 12.3525H0V15.5527H3.19761V12.3525Z" fill="#DC0000" />
                                            <path d="M3.19761 18.7461H0V21.9463H3.19761V18.7461Z" fill="#DC0000" />
                                            <path d="M3.19761 25.1436H0V28.3437H3.19761V25.1436Z" fill="#DC0000" />
                                            <path d="M3.19761 31.5371H0V34.7373H3.19761V31.5371Z" fill="#DC0000" />
                                            <path d="M3.19761 37.9316H0V41.1318H3.19761V37.9316Z" fill="#DC0000" />
                                            <path d="M3.19761 44.3291H0V47.5293H3.19761V44.3291Z" fill="#DC0000" />
                                            <path d="M60.0003 12.3525H56.8027V15.5527H60.0003V12.3525Z" fill="#DC0000" />
                                            <path d="M60.0003 18.7461H56.8027V21.9463H60.0003V18.7461Z" fill="#DC0000" />
                                            <path d="M60.0003 25.1436H56.8027V28.3437H60.0003V25.1436Z" fill="#DC0000" />
                                            <path d="M60.0003 31.5371H56.8027V34.7373H60.0003V31.5371Z" fill="#DC0000" />
                                            <path d="M60.0003 37.9316H56.8027V41.1318H60.0003V37.9316Z" fill="#DC0000" />
                                            <path d="M60.0003 44.3291H56.8027V47.5293H60.0003V44.3291Z" fill="#DC0000" />
                                            <path d="M18.4282 41.6759H16.1963L24.6828 18.3242H26.9626L35.4491 41.6759H33.2172L25.9042 21.0956H25.7444L18.4314 41.6759H18.4282ZM20.0334 32.725H31.6088V34.6419H20.0334V32.725Z" fill="#DC0000" />
                                            <path d="M40.2966 18.3242V41.6759H38.167V18.3242H40.2966Z" fill="#DC0000" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_299_657">
                                                <rect width="60" height="60" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>


                                    <div className="mt-10 hh5">Future-Ready Technology</div>
                                    <p>We build websites using modern, scalable technologies that grow with your business.</p>
                                </div>
                            </div>

                            <div className='xl:w-1/3 px-3'>
                                <div className='card'>
                                    <svg width="63" height="65" viewBox="0 0 63 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M31.4907 64.9954C29.419 64.9954 27.6226 63.5011 27.2255 61.4463C26.8238 59.3916 27.9296 57.3232 29.8478 56.5305C30.3759 56.3118 30.931 56.2024 31.4952 56.2024C32.9666 56.2024 34.3252 56.9405 35.1331 58.1797L36.0222 59.542L37.6245 59.346C47.8431 58.0886 52.1444 53.7422 53.9498 50.3116L55.2226 47.8969L52.7808 46.7078C50.3255 45.5141 48.7322 42.9628 48.7232 40.2155V35.3088C48.7232 32.3747 50.4654 29.755 53.16 28.6434L54.9744 27.8916L54.7623 25.9235C54.1529 20.2558 50.673 1.76316 31.4997 1.76316C12.3264 1.76316 8.81492 20.2558 8.20109 25.9235L7.98895 27.8962L9.80789 28.6434C12.507 29.755 14.2627 32.3747 14.2762 35.3179V40.2246C14.2762 44.1974 11.0717 47.4322 7.1359 47.4322C3.20014 47.4322 7.41726e-05 44.1974 7.41726e-05 40.2246V35.3088C-0.0134663 32.3292 1.82804 29.6184 4.58127 28.5659L6.09329 27.9873L6.25126 26.3608C6.67553 21.9598 9.89365 0 31.4997 0C53.1058 0 56.3194 21.9598 56.7482 26.3608L56.9062 27.9873L58.4182 28.5659C61.1714 29.6229 63.0129 32.3246 62.9994 35.2996V40.2292C63.04 43.4138 61.0631 46.2021 58.0842 47.1771L56.8294 47.5871L56.4142 48.8537C55.1324 52.7627 50.9619 59.5556 37.3989 61.1183L35.9907 61.2823L35.3588 62.5626C34.6231 64.0569 33.1426 64.9909 31.4907 65V64.9954ZM55.859 29.8689C52.8892 29.8689 50.4699 32.3109 50.4699 35.3088V40.2246C50.4699 43.2225 52.8892 45.6645 55.859 45.6645C58.8289 45.6645 61.2481 43.2225 61.2481 40.2246V35.3088C61.2481 32.3109 58.8289 29.8689 55.859 29.8689ZM7.14042 29.8689C6.1971 29.8689 5.2628 30.1195 4.44586 30.5979C2.7849 31.5638 1.75131 33.3725 1.75131 35.3088V40.2246C1.75131 43.2225 4.17054 45.6645 7.14042 45.6645C10.1103 45.6645 12.5295 43.2225 12.5295 40.2246V35.3088C12.5295 33.3725 11.4959 31.5638 9.83497 30.5979C9.01803 30.1195 8.08374 29.8689 7.14042 29.8689Z" fill="#DC0000" />
                                    </svg>

                                    <div className="mt-10 hh5">Ongoing Support</div>
                                    <p>We stay with you even after launch, ensuring your website continues to perform and evolve.</p>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>




            </section>

            <GC_FAQ faq={faq} />

            <section className='page-services cta-1 ' >
                <div className='container'>
                    <div className="w-full relative  xl:hidden mb-10 px-5 " data-aos="fade-up">
                        <img className="" src="/assets/img/services/web-development-e-commerce/cta.webp" width="100%" data-aos="fade-up" alt="Ready to Build a Website Drives Real Results" />
                    </div>
                    <div className='flex flex-wrap items-center -mx-20'>
                        <div className='xl:w-1/2 px-20 content-wrapper '>
                            <div className="hh2" >Ready to Build a Website <span className='text-primary'> Drives Real Results?</span></div>
                            <p>Partner with us to design and develop a high-performing, secure, and scalable website tailored to your business goals.</p>
                            <button className="mt-10" data-aos="fade-up" data-aos-delay="200" onClick={openCalendly}> <div>TALK TO OUR EXPERTS<i></i></div></button>
                        </div>
                        <div className='xl:w-1/2 px-20 mt-15 md:mt-0 justify-center content-wrapper hidden xl:flex'>
                            <img src="/assets/img/services/web-development-e-commerce/cta.webp" width="664px" height="432px" alt="Ready to Build a Website Drives Real Results" />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default WebDevelopmentECommerce
